module.exports = __webpack_public_path__ + "img/icon-address.70379483.png";